const FilterOff = () => (
  <>
    <path
      fill="currentColor"
      d="M4.015 4.636a.5.5 0 0 1 .707-.707l14.85 14.85a.5.5 0 0 1-.708.706z"
    />
    <path
      fill="currentColor"
      d="M7.793 7H4.5a.5.5 0 0 0 0 1h4.293zM12.293 11.5H7.308a.5.5 0 1 0 0 1h5.985zM16.121 12.5l-1-1h1.552a.5.5 0 1 1 0 1zM11.621 8l-1-1H19.5a.5.5 0 0 1 0 1zM10.558 16.5a.5.5 0 0 0 .5.5h1.865a.5.5 0 0 0 0-1h-1.865a.5.5 0 0 0-.5.5"
    />
  </>
)
export default FilterOff
